import BaseDynamicComponent from "%/dynamic-component-editor/classes/base-dynamic-component";
import ComponentName from "%/dynamic-component-editor/options/component-name";
import DisplayName from "%/dynamic-component-editor/options/display-name";
import PageTitle from "%/dynamic-component-editor/options/page-title";
import PageKeywords from "%/dynamic-component-editor/options/page-keywords";
import PageDescription from "%/dynamic-component-editor/options/page-description";
import PageSlug from "%/dynamic-component-editor/options/page-slug";
import ProvidesContexts from "%/dynamic-component-editor/options/provides-contexts";
import PageAccess from "%/dynamic-component-editor/options/page-access";

export default class CustomDynamicPage extends BaseDynamicComponent {

  // ComponentName and DisplayName are both hidden from the inspector
  // panel: InspectorHeaderV2 already shows/edits the name above the panel,
  // and component-name is an internal identifier the user never needs to
  // re-edit after create. Hiding via option instance (not by filtering in
  // the panel) keeps both classes in the getRootOption fallback flow.
  static standardOptionClasses = [
    new ComponentName("", true),
    new DisplayName("", true),
    PageTitle,
    PageKeywords,
    PageDescription,
    ProvidesContexts,
    PageSlug,
    PageAccess,
  ];
}
